import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.array.map";
import "regenerator-runtime/runtime";
import _groupBy from "lodash/groupBy";
import _get from "lodash/get";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { convertCentsAmountToDollarsAmount, convertPortalToProviderAccount } from "./fdp-to-yodlee-transforms";
import { GET_FINANCIAL_DATA_PROFILE_FOR_USER } from "../lib/queries/financial-data";
/**
 * Fetches the financial data for a user, which consists of a user's financial portals and accounts
 * @param {object} apolloClient - The apollo client used to perform queries
 * @returns {object} The financial portals and accounts for a user
 */

export var fetchFinancialData = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(apolloClient) {
    var financialDataResponse;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return apolloClient.query({
              query: GET_FINANCIAL_DATA_PROFILE_FOR_USER,
              fetchPolicy: 'network-only'
            });

          case 2:
            financialDataResponse = _context.sent;
            return _context.abrupt("return", _get(financialDataResponse, 'data'));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFinancialData(_x) {
    return _ref.apply(this, arguments);
  };
}();
/**
 * Transforms a financial data response from the FDP backend with portals and financial accounts to a legacy Yodlee provider
 * accounts and yodlee account data model compatible with the existing clients
 */

export var transformFinancialDataProfileToLegacyDataShape = function transformFinancialDataProfileToLegacyDataShape(financialDataResponse) {
  var financialPortals = _get(financialDataResponse, 'linkedFinancialPortals.portals', []);

  var financialAccounts = _get(financialDataResponse, 'financialAccounts.accounts', []);

  var accountSums = _get(financialDataResponse, 'financialAccountTypeSums', {});

  var financialAccountsByPortalId = _groupBy(financialAccounts, function (financialAccount) {
    return _get(financialAccount, 'financialPortal.id');
  });

  var providerAccounts = financialPortals.map(function (portal) {
    return convertPortalToProviderAccount(portal, _get(financialAccountsByPortalId, portal.id, []));
  });
  return {
    is_fdp_shim: true,
    provider_accounts: providerAccounts,
    sum_assets: convertCentsAmountToDollarsAmount(_get(accountSums, 'assets')),
    sum_bank_balances: convertCentsAmountToDollarsAmount(_get(accountSums, 'banks')),
    sum_credit_card_balances: convertCentsAmountToDollarsAmount(_get(accountSums, 'creditCards')),
    sum_debts: convertCentsAmountToDollarsAmount(_get(accountSums, 'debts')),
    sum_investment_balances: convertCentsAmountToDollarsAmount(_get(accountSums, 'investments')),
    sum_loan_balances: convertCentsAmountToDollarsAmount(_get(accountSums, 'loans'))
  };
};